import { makeAutoObservable } from "mobx";
import { deleteStaffGroup, getStaffGroupById, searchByPageStaffGroup, saveOrUpdateStaffGroup } from "app/services/ServiceStaffGroup";
import { toast } from "react-toastify";
import { SearchStaffGroup } from "app/common/Model/SearchObject";
import { StaffGroupForm } from "app/common/Model/StaffGroup";

export default class StaffGroupStore {
    openStaffGroupCreateOrUpdate = false;
    searchStaffGroup = new SearchStaffGroup();
    pageStaffGroup = null;
    selectedStaffGroup = new StaffGroupForm();
    openConfirmDeleteStaffGroup = false;
    defaultWorkingStaffGroup = null;

    constructor() {
        makeAutoObservable(this);
    }

    pagingStaffGroup = async () => {
        return await searchByPageStaffGroup(this.searchStaffGroup)
            .then(({ data }) => {
                this.pageStaffGroup = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu nhóm nhân viên có lỗi");
            });
    };

    handleOpenFormCreateOrEdit = (employeeStatusId) => {
        if (employeeStatusId) {
            getStaffGroupById(employeeStatusId)
                .then(({ data }) => {
                    this.selectedStaffGroup = data;
                    this.openStaffGroupCreateOrUpdate = true;
                })
                .catch((error) => {
                    toast.error("Lấy dữ liệu nhóm nhân viên có lỗi");
                    console.error("Lỗi lấy dữ liệu nhóm nhân viên:", error);
                });
        } else {
            this.selectedStaffGroup = new StaffGroupForm();
            this.openStaffGroupCreateOrUpdate = true;
        }
    };

    handleCreateOrEdit = async (employeeStatusData) => {
        try {
            //console.log("Dữ liệu gửi đi:", employeeStatusData);
            const { data } = await saveOrUpdateStaffGroup(employeeStatusData);
            toast.success("Lưu StaffGroup thành công!");
            this.handleClosePopup();
            await this.pagingStaffGroup();
            return data;
        } catch (error) {
            toast.error("Lưu nhóm nhân viên thất bại!");
            console.error("Lưu nhóm nhân viên thất bại!:", error);
        }
    };

    handleDelete = async () => {
        const employeeStatusId = this.selectedStaffGroup?.id;
        if (!employeeStatusId) return;

        deleteStaffGroup(employeeStatusId)
            .then(() => {
                // Nếu đang ở trang > 1 và chỉ còn 1 dòng dữ liệu, thì lùi về trang trước
                if (
                    this.searchStaffGroup?.pageIndex > 1 &&
                    this.pageStaffGroup?.content?.length === 1
                ) {
                    this.searchStaffGroup.pageIndex -= 1;
                }
                toast.success("Xóa nhóm nhân viên thành công!");
                this.pagingStaffGroup();
                this.handleClosePopup();
            })
            .catch((error) => {
                console.error("Lỗi khi xóa nhóm nhân viên:", error);
                toast.error("Xóa nhóm nhân viên thất bại!");
            });
    };

    handleChangeFormSearch = (searchStaffGroup) => {
        this.searchStaffGroup = {
            ...this.searchStaffGroup,
            ...searchStaffGroup,
        };
        this.pagingStaffGroup();
    };

    handleDeleteStaffGroup = (employeeStatus) => {
        this.selectedStaffGroup = employeeStatus;
        this.openConfirmDeleteStaffGroup = true;
    };

    handleClosePopup = () => {
        this.openStaffGroupCreateOrUpdate = false;
        this.openConfirmDeleteStaffGroup = false;
    };

    setDefaultWorkingStaffGroup = (value) => {
        this.defaultWorkingStaffGroup = value;
    };

    resetStore = () => {
        this.searchStaffGroup = new SearchStaffGroup();
        this.pageStaffGroup = null;
        this.selectedStaffGroup = new StaffGroupForm();
        this.openStaffGroupCreateOrUpdate = false;
        this.defaultWorkingStaffGroup = null;
    };

    resetStorePopupStaffGroup = () => {
        this.searchStaffGroup = new SearchStaffGroup();
        this.pageStaffGroup = null;
        this.selectedStaffGroup = new StaffGroupForm();
        this.openStaffGroupCreateOrUpdate = false;
    }
}
